import { render, staticRenderFns } from "./TariffModalCreate.vue?vue&type=template&id=27c8c038"
import script from "./TariffModalCreate.vue?vue&type=script&lang=js"
export * from "./TariffModalCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports